<template>
  <div>
    <VueSlickCarousel
      v-if="!isMobile && showCourseList.length >= DISPLAYING_LIMIT"
      class="vue-slick-carousel"
      v-bind="carouselSettings"
      @beforeChange="carouselBeforeChange"
    >
      <course-card v-for="item in showCourseList" :key="item.id" :info="item" load-image-lazily />
      <template v-if="!isMobile" #prevArrow>
        <div class="arrow-icon arrow-icon__left">
          <PrevArrowIcon :style="getArrowIconStyle(currentCourseNumber <= 0)" />
        </div>
      </template>
      <template v-if="!isMobile" #nextArrow>
        <div class="arrow-icon arrow-icon__right">
          <NextArrowIcon :style="getArrowIconStyle(currentCourseNumber >= courseListLength - DISPLAYING_LIMIT)" />
        </div>
      </template>
    </VueSlickCarousel>
    <div v-else class="slide-carousel">
      <course-card
        v-for="item in showCourseList"
        :key="item.id"
        :info="item"
        :class="{
          'card--fixed-width': !isMobile,
        }"
        load-image-lazily
      />
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';

import CourseCard from './course-card.vue';
import PrevArrowIcon from './icon/leftArrow.svg';
import NextArrowIcon from './icon/rightArrow.svg';

import { DISPLAYING_LIMIT } from '../shared';

export default {
  name: 'course-card-carousel',

  components: {
    CourseCard,
    VueSlickCarousel,
    PrevArrowIcon,
    NextArrowIcon,
  },

  props: {
    courseList: {
      type: Array,
    },
  },

  data() {
    return {
      isMobile: false,
      currentCourseNumber: 0,
      courseListLength: this.courseList.length,
      DISPLAYING_LIMIT,
    };
  },

  computed: {
    showCourseList() {
      return this.courseList;
    },

    carouselSettings() {
      return {
        dots: false,
        arrows: true,
        edgeFriction: 0.35,
        infinite: false,
        speed: 200,
        slidesToScroll: 4,
        slidesToShow: 4,
        cssEase: 'cubic-bezier(0.2, 1, 0.8, 1)',
      };
    },
  },

  created() {
    this.checkIsMobile();
    window.addEventListener('resize', this.checkIsMobile);
  },

  destroyed() {
    window.removeEventListener('resize', this.checkIsMobile);
  },

  methods: {
    checkIsMobile() {
      this.isMobile = window.innerWidth < 960;
    },
    carouselBeforeChange(_, newSlideIndex) {
      this.currentCourseNumber = newSlideIndex;
    },
    getArrowIconStyle(isDisable) {
      return { stroke: isDisable ? '#d6d6d6' : '#171717' };
    },
  },
};
</script>

<style scoped lang="scss">
@import './category-main.scss';
@import './course-card-carousel.scss';
@import 'vue-slick-carousel/dist/vue-slick-carousel.css';

.arrow-icon {
  top: calc(50% - 2.8rem);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  border-radius: 0.4rem;

  &::before {
    display: none;
  }

  &:hover {
    background-color: #f8f8f8;
  }

  &__left {
    left: -5.5rem;
  }

  &__right {
    right: -3.9rem;
  }
}

.vue-slick-carousel {
  width: 101.6%;
  max-width: 99.59rem;
  .card__container {
    box-sizing: border-box;
    padding-right: 1.6rem;
  }
}

.slide-carousel {
  display: flex;
  align-items: stretch;
  overflow-x: scroll;

  width: auto;

  visibility: visible;
  transition-timing-function: ease-out;
  transition-duration: 0.8s;
  transform: translate3d(0%, 0, 0) translate3d(0%, 0, 0);

  &::-webkit-scrollbar {
    display: none;
  }

  .card__container {
    box-sizing: border-box;
    padding-right: 1.6rem;

    &:first-child {
      margin-left: 1.6rem;
    }

    &:last-child {
      max-width: 40%;
      padding-right: 0;
    }

    &.card--fixed-width {
      flex: 0 0 25%;
      margin: 0;
    }

    @include tablet {
      flex: 1 0 calc(40% + 1.6rem);
      max-width: calc(40% + 1.6rem);
    }
  }

  @include tablet {
    width: 100vw;
  }
}
</style>
